import { createContext, useState } from "react";
import { ChatMessageContract } from "../types/contracts";

interface SessionProviderProps {
  children: React.ReactNode;
}

export type MessageProps = ChatMessageContract;

interface SessionContextProps {
  token: string;
  setToken: React.Dispatch<React.SetStateAction<string>>;
  messages: Array<MessageProps>;
  setMessages:
    | React.Dispatch<React.SetStateAction<Array<MessageProps>>>
    | React.Dispatch<React.SetStateAction<MessageProps>>
    | any;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  session_start: string;
  setSessionStart: React.Dispatch<React.SetStateAction<string>>;
  socketState: string;
  setSocketState: React.Dispatch<React.SetStateAction<string>>;
  draftInput: string;
  setDraftInput: React.Dispatch<React.SetStateAction<string>>;
  toolStatus: { title: string; tool_name: string } | null;
  setToolStatus: React.Dispatch<React.SetStateAction<{ title: string; tool_name: string } | null>>;
}

const SessionContext = createContext({} as SessionContextProps);

export const SessionProvider = ({ children }: SessionProviderProps) => {
  const [token, setToken] = useState("");
  const [messages, setMessages] = useState<MessageProps[]>([]);
  const [name, setName] = useState("");
  const [session_start, setSessionStart] = useState("");
  const [socketState, setSocketState] = useState("");
  const [draftInput, setDraftInput] = useState("");
  const [toolStatus, setToolStatus] = useState<{ title: string; tool_name: string } | null>(null);

  return (
    <SessionContext.Provider
      value={{
        token,
        setToken,
        messages,
        setMessages,
        name,
        setName,
        session_start,
        setSessionStart,
        socketState,
        setSocketState,
        draftInput,
        setDraftInput,
        toolStatus,
        setToolStatus,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export default SessionContext;
